/**
 *头部
 *@prop {string} title 页面标题
 *@prop {string} link 返回地址
 *@prop {string} step 返回步数
 *@prop {boolean} noBorder 返回步数
 */
Vue.component('page-header', {
	template:
	'<div class="page-header" :class="{noborder: noBorder}">\n' +
	'    <div class="back" @click="goBack">' +
	'        <span class="iconfont icon-fanhui"></span>\n' +
	'    </div>' +
	'    <p class="title">{{title}}</p>' +
	'</div>',
	props: {
		title: String,
		link: String,
		noBorder: {
			type: Boolean,
			default: false
		},
		step: {
			type: Number,
			default: -1
		}
	},
	methods: {
		goBack() {
			if (this.link) {
				location.href = this.link;
			} else {
				history.go(this.step);
			}
		}
	}
});

/**
 *底部导航
 *@prop {number, string} active 激活索引
 */
Vue.component('footer-nav', {
	template:
	'<div class="footer-nav">\n' +
	'    <div class="nav" v-for="(item, index) in navList" :key="item.title" :class="{active: index == active}" @click="changeNav(item, index)">\n' +
	'        <span class="iconfont" :class="item.icon"></span>\n' +
	'        <p class="title">{{item.title}}</p>\n' +
	'    </div>\n' +
	'</div>',
	props: {
		active: {
			type: [String, Number],
			default: 0
		}
	},
	data() {
		return {
			navList: [
				{
					title: '首页',
					icon: 'icon-shouye1',
					link: 'index.html'
				},
                {
                    title: '安全工程师',
                    icon: 'icon-shengchanguanli',
                    link: 'pages/major/home.html?mid=11'
                },
				{
					title: '客服',
					icon: 'icon-xiaoxi1',
					link: 'https://ykf-webchat.7moor.com/wapchat.html?accessId=6bd46320-c33b-11eb-b7b4-9b338f0b0f32&fromUrl=http://wx.zkjan.com&urlTitle=%E5%BE%AE%E4%BF%A1&language=ZHCN'
				},
                {
                    title: '消防工程师',
                    icon: 'icon-jingbao',
                    link: 'pages/major/home.html?mid=13'
                },
				{
					title: '我的',
					icon: 'icon-yonghu',
					link: 'pages/user/class.html'
				},
			]
		}
	},
	methods: {
		changeNav(nav, index) {
			if (index == this.active) {
				return;
			}
			location.href = nav.link;
		}
	}
});
